import styled, { keyframes, css } from 'styled-components';

const fadeIn = keyframes`
    0%{
        opacity: 0;
        top: -10.2rem;
    }
    100%{
        opacity: 1;
        top: -8.2rem;
    }
`;

export const ConditionalContainer = styled.div`
  width: 68rem;
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  width: 60%;
  align-items: center;



`;

export const Wrapper = styled.div`
  position: relative;
  width: 6rem;
  height: 5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-left: 8.5rem;
`;
export const EdgeLabel = styled.div`
  position: absolute;
  opacity: ${({ status }) => status ? '1' : '0'};
  visibility: ${({ status }) => status ? 'visible' : 'hidden'};
  transform: translateY(5.2rem);
  transition: opacity 0.2s ease-in-out;


  p{
    text-align: center;
    display: inline-block;
    border-radius: 4px;
    background-color: #40e5a0;
    padding: 3px 6px;


  }

`;


export const WrapperRef = styled.div`
  position: absolute;
  width: 0.1px;
  height: 0.1px;
  top: 50%;
  right: -3rem;
  z-index: 5000;
`;

export const Conditional = styled.div`
  width: 3.898125rem;
  height: 3.898125rem;
  background-color: #fffdd3;
  transform: rotate(45deg);
  border: 2px solid #40e4a0;
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;

  div {
    &.xArrowDark {
      z-index: 0;
      path {
        filter: brightness(50%);
      }
    }
    &.xArrowLight {
      z-index: 5000;
      path {
        filter: brightness(100%);
        transition: filter 0.5s;
      }
    }
  }
`;

export const Item = styled.div`
  position: relative;
  background: #fff;
  font-size: 0.588125rem;
  color: #42464c;
  font-weight: 600;
  padding: 1.553125rem 0;
  width: 12.46785rem;
  margin-left: 100px;

  border: 2px solid #40e4a0;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  line-height: 0.889375rem;

  margin: 1.875rem 0;

  &:hover {
  }

  &.firstItem {
    margin-top: 0;
  }
  &.lastItem {
    margin-bottom: 0;
  }
  span {
    width: 80%;
    overflow-wrap: break-word;
    text-align: center;
  }

  cursor: pointer;
`;
export const Button = styled.div`
  position: absolute;
  width: 2.970625rem;
  height: 2.970625rem;
  border-radius: 50%;
  background: #fff;
  left: -30%;
  top: calc(50% - 1.4853125rem);
  z-index: 50;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Anchor = styled.div`
  position: absolute;
  width: 0.1px;
  height: 0.1px;
  background-color: blue;
  top: calc(50%);
  left: -1.75rem;
  z-index: 5000;
`;

export const Popper = styled.div`
  position: absolute;
  display: flex;
  background-color: #fff;
  box-shadow: 0px 3.76497px 7.52994px rgba(77, 68, 68, 0.25);
  border-radius: 2px;
  width: 12.11875rem;
  text-align: center;
  padding: 1.4rem 1.1rem;

  top: -8.2rem;

  animation: ${({ isOpen }) =>
    isOpen &&
    css`
      ${fadeIn} 0.4s ease-in forwards
    `};

  &:after {
    content: '';

    display: block;
    position: absolute;
    bottom: -0.625rem;
    left: calc(50% - 0.583rem);

    border-left: 0.583rem solid transparent;
    border-right: 0.583rem solid transparent;
    border-top: 0.833rem solid #f5f5f5;
  }

  span {
    color: #42464c;
    font-size: 0.83125rem;
    font-weight: 600;
  }
`;


export const DivIcon = styled.div`
  position: absolute;
  top: 1.0875rem;
  right: 3.875rem;
  cursor: pointer;

  svg {
    height: 1rem;
  }
`;

export const ConfirmContainer = styled.div`
  width: 25.8rem;
  min-height: 18.06025rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  /* padding-bottom: 2rem; */
  border-radius: 2px;

  animation: ${({ confirm }) =>
    confirm &&
    css`
      ${fadeIn} 0.4s ease-in forwards
    `};
`;
export const Header = styled.div`
  margin: 1.765rem 0 0.8825rem 1.765rem;
  display: flex;

  strong {
    margin-left: 0.70625rem;
    font-size: 1.1rem;
  }
`;

export const Title = styled.span`
  margin: 0 0 1.7706rem 1.765rem;
  color: #585e66;
  font-size: 0.825rem;
`;

export const ConditionalDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 1.765rem;
  div {
    position: relative;
    width: 10.47125rem;
    padding: 1.353125rem 1.23125rem;
    border: 1px solid #40e5a0;
    line-height: 0.74375rem;

    svg {
      position: absolute;
      height: 2rem;
      bottom: -1.2rem;
      left: -1.2rem;
    }
  }

  span {
    font-size: 0.588125rem;
    color: #42464c;
    font-weight: 600;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;

  button {
    outline: none;
    font-size: 0.70625rem;
    font-weight: 700;
    line-height: 0.889375rem;
    padding: 0.794375rem 3.6675rem;
    border-radius: 0.375rem;

    &.cancelButton {
      background-color: #fff;
      border: 1.2px solid #d4d6da;
      color: #7e858f;
      margin-right: 0.70625rem;

      :hover {
        background-color: #d4d6da;
      }
    }

    &.confirmButton {
      background: #585e66;
      color: #fff;
      border: 1.2px solid #585e66;
    }
  }
`;

